import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var MailTemplateApi = /** @class */ (function () {
    function MailTemplateApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    MailTemplateApi.initialize = function (basePath, fetchApi) {
        if (!MailTemplateApi.instance) {
            MailTemplateApi.instance = new MailTemplateApi(basePath, fetchApi);
        }
        return MailTemplateApi.instance;
    };
    MailTemplateApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1MailTemplateApi(new Configuration(config));
    };
    return MailTemplateApi;
}());
export { MailTemplateApi };
